<template>
    <div class="app_container">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="通知正文" name="first">
                <div>
                    <img src="../../../assets/image/jiaxing/3.png" alt />
                </div>
            </el-tab-pane>
            <el-tab-pane label="报名表" name="second">
                <img src="../../../assets/image/jiaxing/4.png" alt />
            </el-tab-pane>
            <el-tab-pane label="健康承诺书" name="third">
                <img src="../../../assets/image/jiaxing/5.png" alt />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        activeName: 'first'
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<style scoped>

</style>
